import React from 'react';
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useCancelSubscription } from '../../../hooks/subscriptions/mutations';
import { useTeamModal } from '../../../hooks/subscriptions/useTeamModal';
import { formatSubscriptionEndDate } from '../../../utils/subscriptionUtils';
import AccountSingleButton from '../AccountSingleButton';
import AccountPageConstants from 'constants/AccountPageConstants';

/**
 * Final confirmation page for cancelling subscription
 */
const BillingModalPauseConfirm = () => {
  const { navigateToPage } = useTeamModal();
  const { data: subscription } = useSubscription();
  const cancelMutation = useCancelSubscription();

  const handleCancelClick = () => {
    if (subscription && subscription.id) {
      cancelMutation.mutate(subscription.id, {
        onSuccess: () => {
          // Navigate back to main billing page after successful cancellation
          navigateToPage(AccountPageConstants.PLAN_AND_BILLING);
        }
      });
    }
  };

  return (
    <div>
      <AccountSingleButton
        error={cancelMutation.error}
        onClick={handleCancelClick}
        loading={cancelMutation.isPending}
        header="Cancel Subscription"
        button="Cancel Subscription"
        disclaimer="By canceling your subscription, you agree to remove
                    access to Delve from you and your team members
                    after your next billing cycle ends."
        body={
          <p>
            After canceling, you and your team members will still be able to
            use Delve until {formatSubscriptionEndDate(subscription.current_period_end)}.
            Your research stays in Delve even while your subscription is canceled.
            You can renew your subscription in the future to pick up where
            you left off.
          </p>
        }
      />
    </div>
  );
};

export default BillingModalPauseConfirm;